import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle, useContext } from "react";
import LoadingSpinner from "../../../baseComponents/LoadingSpinner";

import { SLCreateSLBatchContext } from "../../../contexts/SLCreateSLBatchContext";
import { SLLoadingStatus } from "../../../utilities/utilities";
import LineItems, { ILineItemsGridRef } from "./LineItems";

export interface ISLCreateLineItemsGridRef {
  getLineItems: () => string[][];
  setLineItems: (lineItems: string[][]) => void;
  reset: () => void;
}

const SLCreateLineItems = forwardRef((props, ref: React.Ref<ISLCreateLineItemsGridRef>) => {
  const slCreateContext = useContext(SLCreateSLBatchContext);
  const [loadingStatus, setLoadingStatus] = useState(SLLoadingStatus.Idle);
  const lineItemsRef = useRef<ILineItemsGridRef>(null);

  useEffect(() => {
    return () => {
      setLoadingStatus(SLLoadingStatus.Idle);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    getLineItems() {
      if (lineItemsRef.current) {
        return lineItemsRef.current.getLineItems();
      }
      return [];
    },
    setLineItems(lItems: string[][]) {
      if (lineItemsRef.current) {
        return lineItemsRef.current.setLineItems(lItems);
      }
    },
    reset() {
      if (lineItemsRef.current) {
        return lineItemsRef.current.reset();
      }
    }
  }));

  useEffect(() => {
    setLoadingStatus(slCreateContext.loadingStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slCreateContext.loadingStatus, slCreateContext.entry]);

  if (loadingStatus === SLLoadingStatus.Idle || loadingStatus === SLLoadingStatus.Rejected) {
    return null;
  } else if (loadingStatus === SLLoadingStatus.Pending) {
    return <LoadingSpinner label="Loading line items" />;
  }
  return (
    <>
      <LineItems ref={lineItemsRef} readOnly={slCreateContext.isReadOnly} />
    </>
  );
});
SLCreateLineItems.displayName = "SLCreateLineItems";

export default SLCreateLineItems;
